import { render, staticRenderFns } from "./ForgotPassword-1.vue?vue&type=template&id=3ae1d46a&scoped=true&"
import script from "./ForgotPassword-1.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword-1.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword-1.vue?vue&type=style&index=0&id=3ae1d46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1d46a",
  null
  
)

export default component.exports